import { COMPANY_STATUS, COMPANY_STATUS_ERROR, COMPANY_STATUS_SUCCESS, GET_COMPANY_DETAIL, GET_COMPANY_DETAIL_ERROR, GET_COMPANY_DETAIL_SUCCESS, GET_ONE_COMPANY_DETAIL, GET_ONE_COMPANY_DETAIL_ERROR, GET_ONE_COMPANY_DETAIL_SUCCESS, NEW_COMPANY_ADD, NEW_COMPANY_ADD_ERROR, NEW_COMPANY_ADD_SUCCESS, DOWNLOAD, DOWNLOAD_SUCCESS,
   DOWNLOAD_ERROR,  DELETE_ORGANIZATION,DELETE_ORGANIZATION_SUCCESS,DELETE_ORGANIZATION_FAIL } from "./actionTypes"

  
  const initialState = {
    detailsSuccess : null,
    detailsFailed : null,
    companyAdded : null,
    companyFailed : null,
    statusUpdate : null,
    statusError : null,
    loading: false,
    companyDetails:null,
    companyDetailsError:null,
    downloadData:null,
    deleteOrgSuccess: null, 
    deleteOrgFail: null,
  }
  
  const myCompanyReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_COMPANY_DETAIL:
        state = {
          ...state,
          detailsSuccess : null,
          detailsFailed : null,
          loading: true,
          test:null,
        }
        break
      case GET_COMPANY_DETAIL_SUCCESS:
     
        state = {
          ...state,
          detailsSuccess : action.payload,
          detailsFailed : null,
          loading: false,
        }
        break
      case GET_COMPANY_DETAIL_ERROR:
        state = { 
            ...state ,
            detailsSuccess : null,
            detailsFailed : action.payload,
            loading: false,
        }
        break

        case NEW_COMPANY_ADD:
        state = {
          ...state,
          companyAdded : null,
          companyFailed : null,
          loading: true,
        }
        break
      case NEW_COMPANY_ADD_SUCCESS:
        state = {
          ...state,
          companyAdded : action.payload,
          companyFailed : null,
          loading: false,
        }
        break
      case NEW_COMPANY_ADD_ERROR:
        state = { 
            ...state ,
            companyAdded : null,
            companyFailed : action.payload,
            loading: false,
        }
        break

        case COMPANY_STATUS :
          state = {
            ...state,
            statusUpdate : null,
            statusError : null,
            loading: true,
          }
          break
        case COMPANY_STATUS_SUCCESS:
          state = {
            ...state,
            statusUpdate : action.payload,
            statusError : null,
            loading: false,
          }
          break
        case COMPANY_STATUS_ERROR:
          state = { 
              ...state ,
              statusUpdate : null,
              statusError : action.payload,
              loading: false,
          }
          break
          case GET_ONE_COMPANY_DETAIL:
          state = { 
              ...state ,
              companyDetails:null,
    companyDetailsError:null,
          }
          break
          case GET_ONE_COMPANY_DETAIL_SUCCESS:
          state = { 
              ...state ,
              companyDetails:action.payload,
    companyDetailsError:null
          }
          break
          case GET_ONE_COMPANY_DETAIL_ERROR:
          state = { 
              ...state ,
              companyDetails:null,
    companyDetailsError:action.payload
          }
          break
          case DOWNLOAD:
            state = { 
              ...state ,
              downloadData:null,
              companyDetailsError:null
            }
          break
          case DOWNLOAD_SUCCESS:
            state = { 
              ...state ,
              downloadData:action.payload
            }
          break
          case DOWNLOAD_ERROR:
            state = { 
              ...state ,
              companyDetailsError:action.payload
            }
          break
            // delete organization
            case DELETE_ORGANIZATION:
              state = { 
                ...state,
                loading: true,
                deleteOrgSuccess: null,
                deleteOrgFail:null
              }
            break
            case DELETE_ORGANIZATION_SUCCESS:
              state = { 
                ...state ,
                loading: false,
                deleteOrgSuccess:action.payload,
                deleteOrgFail: null
              }
            break
            case DELETE_ORGANIZATION_FAIL:
              state = { 
                ...state ,
                loading: false,
                deleteOrgSuccess:null,
                deleteOrgFail:action.payload
              }
            break
        default:
            state = { ...state }
            break
    }
    return state
  }
  
  export default myCompanyReducer
  